/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export class InvoiceExternalSpOrderDTO{
   uuid : string | undefined = undefined;
   orderUuid : string | undefined = undefined;
   paymentTimeLimit : number | undefined = undefined;
   currencyCode : string | undefined = undefined;

  constructor(uuid: string, orderUuid: string, paymentTimeLimit: number, currencyCode : string) {
    this.uuid = uuid;
    this.orderUuid = orderUuid;
    this.paymentTimeLimit = paymentTimeLimit;
    this.currencyCode = currencyCode;
  }
}
